import React, { useState } from 'react';
import ToolLayout from '../../components/ToolLayout';
import { Textarea } from '../../components/ui/textarea';
import { Button } from '../../components/ui/button';
import { Label } from '../../components/ui/label';
import { useToast } from '../../hooks/use-toast';
import { Copy, Lock } from 'lucide-react';

const Base64EncoderPage = () => {
  const { toast } = useToast();
  const [input, setInput] = useState('');
  const [output, setOutput] = useState('');

  const encode = () => {
    try {
      const encoded = btoa(input);
      setOutput(encoded);
    } catch (err) {
      toast({
        title: 'Error',
        description: 'Failed to encode: ' + err.message,
        variant: 'destructive'
      });
    }
  };

  const decode = () => {
    try {
      const decoded = atob(input);
      setOutput(decoded);
    } catch (err) {
      toast({
        title: 'Error',
        description: 'Invalid Base64 string',
        variant: 'destructive'
      });
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(output);
    toast({
      title: 'Copied!',
      description: 'Output copied to clipboard',
    });
  };

  const clear = () => {
    setInput('');
    setOutput('');
  };

  return (
    <ToolLayout
      title="Base64 Encoder/Decoder"
      description="Encode or decode Base64 strings quickly and easily. Perfect for encoding binary data or decoding Base64 strings."
      icon={Lock}
    >
      <div className="space-y-6">
        <div>
          <Label htmlFor="input">Input</Label>
          <Textarea
            id="input"
            placeholder="Enter text to encode or Base64 string to decode..."
            value={input}
            onChange={(e) => setInput(e.target.value)}
            rows={8}
            className="font-mono text-sm"
          />
        </div>

        <div className="flex flex-wrap gap-3">
          <Button onClick={encode}>Encode to Base64</Button>
          <Button onClick={decode} variant="secondary">Decode from Base64</Button>
          <Button onClick={clear} variant="outline">Clear</Button>
        </div>

        {output && (
          <div>
            <div className="flex items-center justify-between mb-2">
              <Label>Output</Label>
              <Button onClick={copyToClipboard} variant="ghost" size="sm">
                <Copy className="w-4 h-4 mr-2" />
                Copy
              </Button>
            </div>
            <Textarea
              value={output}
              readOnly
              rows={8}
              className="font-mono text-sm bg-gray-50 dark:bg-gray-900"
            />
          </div>
        )}
      </div>
    </ToolLayout>
  );
};

export default Base64EncoderPage;